/*
* show navigation on scroll top
* this also used by mobile menu
*/

import $ from 'jquery';

// set position absolute above top screen (hidden), set position fixed once all element visible
const onScrollUp = () => {
    const $el = $('.js-flex-fixed');
    const elTop = $el.css('top').replace('px', '') * 1;
    const elHeight = $el.outerHeight();
    const scrollTop = Math.max($(window).scrollTop(), 0);

    if (scrollTop === 0) {
        $el.removeClass('fixed');
        return;
    }

    // set element above screen if no visible, or set fixed on screen top if all visible
    if (!$el.hasClass('placed') && !$el.hasClass('fixed')) {
        if (scrollTop < elHeight) return;

        $el.css('top', $(window).scrollTop() - elHeight)
            .addClass('placed');
    } else if (scrollTop <= elTop) {
        $el.css('top', 0)
            .addClass('fixed')
            .removeClass('placed');
    }
};

// set position absolute on current fixed position
const onScrollDown = () => {
    const $el = $('.js-flex-fixed');
    const elTop = $el.css('top').replace('px', '') * 1;
    const elHeight = $el.outerHeight();
    const scrollTop = Math.max($(window).scrollTop(), 0);

    // if placed and not visible -> remove class
    if ($el.hasClass('placed') && scrollTop > elTop + elHeight) {
        $el.removeClass('placed');
    }

    // if fixed -> set placed and top
    if ($el.hasClass('fixed')) {
        $el.css('top', scrollTop)
            .addClass('placed')
            .removeClass('fixed');
    }
};

const initDesktopMenu = () => {
    const $el = $('.js-flex-fixed');
    if (!$el.length) { return; }

    let lastScrollTop = 0;
    let st;

    $(window).scroll(function () {
        st = $(this).scrollTop();
        if (st > lastScrollTop) {
            onScrollDown();
        } else {
            onScrollUp();
        }
        lastScrollTop = st;
    });
};

const initDropdownNav = () => {
    const $el = $('.js-dropdown > a');
    if ($el.length <= 0) return;

    $el.click(function (e) {
        e.preventDefault();

        const $par = $(this).closest('.js-dropdown');

        if ($par.hasClass('open')) {
            $par.removeClass('open');
        } else {
            $('.js-dropdown').removeClass('open');
            $par.addClass('open');
        }
    });

    // close on click body
    $('body').click(e => {
        if ($(e.target).closest('.js-dropdown').length > 0) return;

        $('.js-dropdown').removeClass('open');
    });
};

$(() => {
    initDesktopMenu();
    initDropdownNav();
});



// WEBPACK FOOTER //
// ./src/sections/desktop-header/s-desktop-header.js